import {
  GET_CEREMONIES_SUCCESS,
  GET_CEREMONIES_FAIL,
  GET_CEREMONY_PROFILE_SUCCESS,
  GET_CEREMONY_PROFILE_FAIL,
  ADD_CEREMONY_SUCCESS,
  ADD_CEREMONY_FAIL,
  UPDATE_CEREMONY_SUCCESS,
  UPDATE_CEREMONY_FAIL,
  DELETE_CEREMONY_SUCCESS,
  DELETE_CEREMONY_FAIL,
  DELETE_CEREMONY,
  ADD_NEW_CEREMONY,
  UPDATE_CEREMONY
  
} from "./actionTypes";

const INIT_STATE = {
  ceremonies: [],
  ceremonyProfile: {},
  error: {},
  loading:false
};

const ceremonies = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_CEREMONIES_SUCCESS:
      return {
        ...state,
        ceremonies: action.payload.data,
        total_pages:action.payload.total_pages
      }

    case GET_CEREMONIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      case ADD_NEW_CEREMONY:
        return {
          ...state,
          loading:true
        }
    case ADD_CEREMONY_SUCCESS:
      return {
        ...state,
        ceremonies: [...state.ceremonies, action.payload],
        loading:false
      }

    case ADD_CEREMONY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_CEREMONY:
        return {
          ...state,
          loading:true
        }
    case UPDATE_CEREMONY_SUCCESS:
      return {
        ...state,
        ceremonies: state.ceremonies.map(ceremony =>
          ceremony.id.toString() === action.payload.id.toString()
            ? { ...ceremony, ...action.payload }
            : ceremony
        ),
        loading:false
      }

    case UPDATE_CEREMONY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_CEREMONY:
      return {
        ...state,
        loading:true
      }
    case DELETE_CEREMONY_SUCCESS:
      return {
        ...state,
        ceremonies: state.ceremonies.filter(
          ceremony => ceremony.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_CEREMONY_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CEREMONY_PROFILE_SUCCESS:
      return {
        ...state,
        ceremonyProfile: action.payload,
      }

    case GET_CEREMONY_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default ceremonies;
